import Routes from './routes'


export default function App() {
  return <Routes />;
}
